export default __webpack_public_path__ + "static/media/11.17.10c4890a.jpg";